// src/utils/stripe.jsx
import { loadStripe } from "@stripe/stripe-js";

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Never call loadStripe("") or Stripe will throw IntegrationError.
// Return Promise<null> so UI can handle "Stripe not configured".
export const stripePromise = publishableKey
  ? loadStripe(publishableKey)
  : Promise.resolve(null);

if (!publishableKey && process.env.NODE_ENV !== "production") {
  // eslint-disable-next-line no-console
  console.warn(
    "[stripe] Missing REACT_APP_STRIPE_PUBLISHABLE_KEY. Stripe will be disabled."
  );
}